import type { STTHeroDisplayMode } from "../hooks/useSTTHeroPlayback";
import type { Segment } from "@ui/components/demos/STT/types";

export function shouldShowSttHeroVideoUploadPreview(
  displayMode: STTHeroDisplayMode,
  uploadFileName: string | null,
  uploadedMediaKind: "audio" | "video" | null,
) {
  return displayMode === "videoPreview" && uploadFileName !== null && uploadedMediaKind === "video";
}

export function getSttHeroPreviewFileType(fileNameOrUrl: string | null | undefined, fallbackType?: string | null) {
  if (!fileNameOrUrl) {
    return fallbackType ?? "video";
  }

  const base = fileNameOrUrl.split("?")[0] ?? fileNameOrUrl;
  const extension = base.split(".").pop()?.toLowerCase();
  if (!extension || extension === base.toLowerCase()) {
    return fallbackType ?? "video";
  }
  return extension;
}

export function getSttHeroPreviewDurationSeconds(segments: Segment[]) {
  if (!segments.length) return 0;
  return segments.reduce((maxDuration, segment) => Math.max(maxDuration, segment.end), 0);
}

export function formatSttHeroPreviewTime(durationSeconds: number) {
  const totalSeconds = Math.max(0, Math.floor(durationSeconds));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}
